module.exports = __webpack_public_path__ + "static/media/8043830951_c54c3eecf1_z.255a24ce.jpg";